import React from "react";

const NotListing = () => {
  return (
    <div className="h-1/2 flex justify-center items-center">
      <h4 className="text-2xl">Currently no listings match your search.</h4>
    </div>
  );
};

export default NotListing;
